module.exports = __webpack_public_path__ + "img/20.3c96e353.jpg";